import Script from 'next/script'
import { GoogleTagManager } from '@next/third-parties/google'

type Props = {
  /**
   * A/B testing and ad-serving scripts. Turned off for the admin panel: no
   * admin page is an experiment variant or carries an ad slot, and since ad
   * blockers block both hosts outright every admin page load logged two
   * ERR_BLOCKED_BY_CLIENT failures plus the rejected `beforeInteractive`
   * script's error event — noise in the one console the editor console is
   * actually debugged from.
   */
  withMarketingScripts?: boolean
}

/**
 * Contents of <head> tag common for all pages
 * to be used in app and pages routers
 */
export const CommonHeaders = ({ withMarketingScripts = true }: Props) => {
  return (
    <>
      <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER!} />

      {withMarketingScripts && (
        <>
          {/* Convert Experiences A/B Testing */}
          <Script
            id="convert-experiences-vars"
            strategy="beforeInteractive"
            dangerouslySetInnerHTML={{
              __html: `
            var _conv_page_type = "";
            var _conv_category_id = "";
            var _conv_category_name = "";
            var _conv_product_sku = "";
            var _conv_product_name = "";
            var _conv_product_price = "";
            var _conv_customer_id = "";
            var _conv_custom_v1 = "";
            var _conv_custom_v2 = "";
            var _conv_custom_v3 = "";
            var _conv_custom_v4 = "";
          `,
            }}
          />
          <Script
            id="convert-experiences"
            strategy="beforeInteractive"
            src={`//cdn-4.convertexperiments.com/v1/js/10019380-10019810.js?environment=${process.env.NEXT_PUBLIC_CONVERT_ENVIRONMENT}`}
          />
          {/* Google Ads */}
          <link
            rel="preconnect"
            href="https://securepubads.g.doubleclick.net"
            crossOrigin="anonymous"
          />
          <link
            rel="preconnect"
            href="https://pagead2.googlesyndication.com"
            crossOrigin="anonymous"
          />

          <Script
            id="gpt-script"
            strategy="afterInteractive"
            data-cookieconsent="marketing"
            crossOrigin="anonymous"
            async
            rel="preload"
            src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
          />

          <Script
            id="gpt-init"
            strategy="afterInteractive"
            data-cookieconsent="marketing"
            dangerouslySetInnerHTML={{
              __html: `
            window.googletag = window.googletag || { cmd: [] };
            googletag.cmd.push(() => {
              // setConfig is the current API for both flags; the equivalent
              // PubAdsService methods are deprecated and GPT logs a warning
              // for each. disableInitialLoad is what makes lazy loading
              // possible at all, since ad-slot-manager.ts fetches a slot only
              // once its container nears the viewport. singleRequest is what
              // lets one fetch cycle batch several slots into one request.
              // Both must be set before enableServices().
              googletag.setConfig({
                disableInitialLoad: true,
                singleRequest: true,
              });
              googletag.enableServices();
            });
          `,
            }}
          />
        </>
      )}
    </>
  )
}
